export default "__VITE_ASSET__BGrweaoi__"